import React from "react";
import "./cta.css";

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <b>Discover why ScroBits is the right partner for your business.</b>
      <h3>
        Prepared to Advance your Digital Transformation? Get in touch with us.
      </h3>
    </div>
    <div className="gpt3__cta-btn">
      <button
        onClick={(e) => {
          e.preventDefault();
          window.location.href = "/get-started";
        }}
        type="button"
      >
        Get Started
      </button>
    </div>
  </div>
);

export default CTA;
